<template>
  <div id="app">
    <el-container :class="classPrefix">
      <el-header
        v-if="$route.name !== 'login' && $route.name !== 'login-prefix'"
      >
        <router-view name="header"></router-view>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <el-footer>
        <router-view name="footer"></router-view>
      </el-footer>
    </el-container>
    <el-drawer
      v-if="classPrefix === 'tembici'"
      size="300px"
      :visible.sync="dialog"
      direction="rtl"
      custom-class="demo-drawer"
      ref="drawer"
    >
      <div class="demo-drawer__content">
        <el-form
          ref="form"
          :model="form"
          label-width="60px"
          label-position="top"
        >
          <el-form-item label="Nome" prop="name">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="E-mail" prop="mail">
            <el-input
              type="email"
              pattern="^[^\s].+[^\s]+@[a-z0-9.-]+\.[a-z]{2,}$"
              v-model="form.mail"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="Telefone" prop="phone">
            <el-input
              v-model="form.phone"
              autocomplete="off"
              type="tel"
              v-mask="'(##) #####-####'"
            ></el-input>
          </el-form-item>
          <el-form-item label="Mensagem" prop="message">
            <el-input type="textarea" v-model="form.message"></el-input>
          </el-form-item>
          <span>
            <el-form-item prop="file">
              <el-upload
                class="upload-demo"
                ref="uploadSuport"
                action="/mail/upload"
                :multiple="true"
                :file-list="fileList"
                :on-preview="handlePreview"
                :auto-upload="false"
              >
                <el-button size="medium" type="success">
                  Anexar documento <i class="el-icon-upload"></i>
                </el-button>
              </el-upload>
            </el-form-item>
          </span>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button type="primary" @click="sendMail()" :loading="loading">
            {{ loading ? "Enviando ..." : "Enviar mensagem" }}
            <i class="el-icon-message"></i>
          </el-button>
          <el-button @click="$refs.drawer.closeDrawer()">Cancelar</el-button>
        </div>
      </div>
    </el-drawer>
    <div v-if="classPrefix === 'tembici'" class="talk-to-us active">
      <div class="form-shortcut">
        <h2 @click="dialog = true">
          Fale com a {{ classPrefix.toUpperCase() }}
        </h2>
      </div>
    </div>
  </div>
</template>
<script>
import { MailServices } from "@/services/mail/mail.services";
import NavBar from "@/components/NavBar";
import FooterComponent from "@/components/FooterComponent";
import SideBar from "@/components/SideBar";
import { mapGetters } from "vuex";

export default {
  components: {
    SideBar,
    NavBar,
    FooterComponent
  },
  data() {
    return {
      dialog: false,
      loading: false,
      fileList: [],
      form: {
        name: "",
        mail: "",
        phone: "",
        message: ""
      }
    };
  },
  methods: {
    ...mapGetters("auth", ["getPrefixRoute"]),
    handlePreview: function(file) {
      const a = document.createElement("a"); //Create <a>
      a.href = file.url;
      a.download = file.name;
      a.click();
    },
    sendMail: function() {
      const vm = this;
      if (!vm.form.mail || !vm.form.name || !vm.form.message) {
        return this.$message({
          type: "error",
          message: "É necessário informar o Nome, E-mail e Mensagem!"
        });
      }

      vm.loading = true;

      MailServices.send(
        vm.form.name,
        vm.form.mail,
        vm.form.phone,
        vm.form.message,
        vm.$refs.uploadSuport.uploadFiles.length === 0
          ? null
          : vm.$refs.uploadSuport.uploadFiles
      )
        .then(response => {
          this.$message({
            type: "success",
            message:
              "Agradecemos seu contato, sua mensagem foi recebida e retornaremos no prazo de 24 horas!"
          });
        })
        .catch(error => {
          this.$message({
            type: "error",
            message: error
          });
        });
      setTimeout(() => {
        vm.fileList = [];
        vm.$refs.form.resetFields();
        vm.$refs.drawer.closeDrawer();
        vm.loading = false;
      }, 1000);
    }
  },
  computed: {
    classPrefix: function() {
      const routerPrefix = this.$route.params.prefix;
      const storePrefix = this.getPrefixRoute();
      return storePrefix || routerPrefix;
    }
  },
  mounted() {}
};
</script>

<style>
/* DEFAULT */
header .el-menu-vertical-demo {
  background-color: #42677c;
}
header > ul.el-menu-vertical-demo > li.el-menu-item,
header > ul.el-menu-vertical-demo > li.el-submenu > .el-submenu__title {
  color: #000000;
  border-bottom-color: transparent;
}
header > ul.el-menu-vertical-demo > li.el-menu-item:hover,
div.el-menu--horizontal
  > ul.el-menu.el-menu--popup.el-menu--popup-bottom-start
  > li.el-menu-item {
  color: #000000;
}
header > ul.el-menu-vertical-demo > li.el-menu-item.is-active:hover {
  color: #000000;
}
header > ul.el-menu-vertical-demo > li.el-menu-item.is-active,
header
  > ul.el-menu-vertical-demo
  > li.el-submenu.is-active
  > .el-submenu__title {
  color: #000000;
  border-bottom-color: #000000;
}

/* TEMBICI */
section.el-container.tembici {
  font-family: "MoriGothic-Regular";
}
section.tembici .portal h1 {
  color: #f90083;
}
section.el-container.tembici header > ul.el-menu-vertical-demo {
  background-color: #f90083;
}
section.el-container.tembici
  header
  > ul.el-menu-vertical-demo
  > li.el-menu-item,
section.el-container.tembici
  header
  > ul.el-menu-vertical-demo
  > li.el-submenu
  > .el-submenu__title {
  color: #ffffff;
  border-bottom-color: transparent;
}
section.el-container.tembici
  header
  > ul.el-menu-vertical-demo
  > li.el-menu-item:hover,
section.el-container.tembici
  header
  > ul.el-menu-vertical-demo
  > li.el-menu-item.is-active:hover,
section.el-container.tembici
  header
  > ul.el-menu-vertical-demo
  > li.el-submenu
  > .el-submenu__title:hover {
  color: #000000;
}
section.el-container.tembici
  header
  > ul.el-menu-vertical-demo
  > li.el-menu-item.is-active {
  color: #000000;
  border-bottom-color: #000000;
}
section.el-container.tembici button.el-button.el-button--primary {
  /* background: rgb(26, 188, 37); */
  /* Changes the text color */
  /* --el-button-text-color: rgb(26, 188, 37); */
  /* Changes the background color */
  /* --el-button-bg-color: rgb(116, 23, 116); */
  /* Changes the border color */
  /* --el-button-border-color: darkorchid; */
}

/* Fale Conosco */
.talk-to-us {
  position: fixed;
  right: 10px;
  top: 120px;
  z-index: 99;
  padding-left: 44px;
  -webkit-transition: 0.35s;
  -moz-transition: 0.35s;
  -ms-transition: 0.35s;
  -o-transition: 0.35s;
  transition: 0.35s;
}
.talk-to-us .form-shortcut {
  border-style: ridge;
  border-width: 1px;
  border-radius: 15px 15px 0px 0px;
  position: absolute;
  left: -86.155px;
  top: 86.155px;
  background-color: rgba(254, 254, 254, 0.7);
  cursor: pointer;
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
}
.talk-to-us .form-shortcut h2 {
  font-family: sans-serif;
  padding: 10px 30px 10px 50px;
  font-size: 20px;
  color: #223140;
  width: 100%;
  white-space: nowrap;
  position: relative;
}
.demo-drawer__content {
  padding: 20px 20px 20px 20px;
}
.demo-drawer__footer {
  position: fixed;
}
</style>
